// JIRA LPPLWEBMOB-563
import { FormElement } from "../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../components/types";
import { Url } from "../../../router/enums";

import { ComponentId } from "./enums";
import { selectFormData } from "./summary.selectors";
import {
  setACAgreeContactEmail,
  setACAgreeDecisionEmail,
  setACAgreeRentinVehicleEmail,
  setACCorrectnessAgreement,
} from "./summary.slice";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  selector: selectFormData,
  //JIRA LPPLWEBMOB-721
  //redirect: Url.AC_SENDING,
  redirect: Url.AC,
  content: [
    {
      title: "Zgody",
      sections: [
        {
          id: "ac-summary-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.CORRECTNESS_AGREEMENT,
              onChange: setACCorrectnessAgreement,
              label: "",
              marketingLabel: "",
              items: [
                {
                  label: "Potwierdzam poprawność wprowadzonych danych",
                  value: "true",
                },
              ],
              required: true,
            },
          ],
        },
        {
          id: "ac-summary-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.AGREE_DECISION_EMAIL,
              onChange: setACAgreeDecisionEmail,
              label: "",
              marketingLabel: "",
              items: [
                {
                  label: "Wyrażam zgodę na przedłożenie decyzji drogą mailową",
                  value: "true",
                },
              ],
              required: false,
            },
          ],
        },
        {
          id: "ac-summary-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.AGREE_RENTIN_VEHICLE_EMAIL,
              onChange: setACAgreeRentinVehicleEmail,
              label: "",
              marketingLabel: "",
              items: [
                {
                  label:
                    "Wyrażam zgodę na potwierdzenie przekazanej informacji dot. najmu pojazdu zastępczego drogą mailową",
                  value: "true",
                },
              ],
              required: false,
            },
          ],
        },
        {
          id: "ac-summary-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.AGREE_CONTACT_EMAIL,
              onChange: setACAgreeContactEmail,
              label: "",
              marketingLabel: "",
              items: [
                {
                  label:
                    "Wyrażam zgodę na kontakt w toku likwidacji szkody drogą mailową",
                  value: "true",
                },
              ],
              required: false,
            },
          ],
        },
      ],
    },
  ],
};
